module.exports = __webpack_public_path__ + "img/fengtao.a034c00c.a034c00c.jpg";